import { render, staticRenderFns } from "./management-vote-detail.vue?vue&type=template&id=a467954c&"
import script from "./management-vote-detail.vue?vue&type=script&lang=js&"
export * from "./management-vote-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports